const t = "_buttonGroup_1o03t_1", o = {
  buttonGroup: t
};
export {
  t as buttonGroup,
  o as default
};
//# sourceMappingURL=button-group.module.less.js.map
